export const smsApiConfig = {
  primary: '/customer/atClient/smsSend',
  primaryCloudflare: '/customer/atClient/smsSendCloudFlare',
  secondary: '/customer/atClient/smsSendTextlocal',
  secondaryCloudflare: '/customer/atClient/smsSendTextlocalCloudFlare',
};

/**
 * 统一根据配置选择短信接口
 * @param {object} options
 * @param {boolean} options.cloudflare 是否走 Cloudflare 验证专用接口
 * @param {boolean} options.isResend 是否为再次发送（走 Textlocal）
 * @param {string} [options.channel] 渠道，默认 whatsapp（目前仅通过请求体透传，不影响 URL）
 */
export function getSmsSendUrl({ cloudflare, isResend, channel = 'whatsapp' }) {
  // 当前后端通过 body.channel 区分渠道，因此这里暂不根据 channel 切换 URL
  void channel; // 避免 eslint no-unused-vars 报错
  if (isResend) {
    return cloudflare ? smsApiConfig.secondaryCloudflare : smsApiConfig.secondary;
  }
  return cloudflare ? smsApiConfig.primaryCloudflare : smsApiConfig.primary;
}

